import api from "./api";
import type ICurrentManager from "@/interfaces/ICurrentManager";

let currentAccount: ICurrentManager | null = null;
let pendingRequest: Promise<ICurrentManager> | null = null;

export const getCurrentAccount = async (): Promise<ICurrentManager> => {
    if (currentAccount) return currentAccount;
    if (pendingRequest) return pendingRequest;

    pendingRequest = api.get("/me")
        .then((response) => {
            currentAccount = response.data.result as ICurrentManager;
            return currentAccount;
        })
        .finally(() => {
            pendingRequest = null;
        });

    return pendingRequest;
};

export const clearAccountCache = () => {
    currentAccount = null;
    pendingRequest = null;
};

export const canManageEmployees = (account: ICurrentManager | null): boolean =>
    account?.role === "owner" || account?.role === "admin";
